import { CODEIT_META_KEY } from 'apps/main/deprecated/shared/constants'
import { NX_PUBLIC_ASSET_URL } from 'apps/main/env'
import Head from 'next/head'

/**
 * 참고: https://developer.twitter.com/en/docs/twitter-for-websites/cards/overview/markup
 */
type TwitterTagsProps = {
  title: string
  description: string
  imageSource?: string
  cardType?: 'summary_large_image' | 'summary' | 'player' | 'app'
}

const TwitterTags = ({
  title,
  description,
  imageSource = `${NX_PUBLIC_ASSET_URL}${CODEIT_META_KEY.IMG_DIRECTORY}`,
  cardType = 'summary_large_image',
}: TwitterTagsProps) => {
  return (
    <Head>
      <meta name="twitter:card" content={cardType} />
      <meta name="twitter:site" content="@codeit" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageSource} />
    </Head>
  )
}

export default TwitterTags
